import React from 'react';
import { KitConnected } from './components/KitConnected';
import { KitGetStarted } from './components/KitGetStarted';
import { KitSyncJobActive } from './components/KitSyncJobActive';
import { useKit } from './hooks/useKit';
const DEFAULT_SYNC_JOB_KEYS = ['MEMBERS', 'NEWSLETTER'];
export const AppsKitSettings = () => {
    const { syncStatus, 
    // actions
    createSyncJob, isCreatingSyncJob, } = useKit();
    // For Kit, we assume it's always connected since it's a simpler integration
    // Show get started if no sync has ever been performed
    if (!syncStatus.hasSynced && !syncStatus.active) {
        return (React.createElement(KitGetStarted, { onGetStarted: () => createSyncJob({ keys: DEFAULT_SYNC_JOB_KEYS }), isLoading: isCreatingSyncJob }));
    }
    if (syncStatus.active) {
        return React.createElement(KitSyncJobActive, { status: syncStatus.progress });
    }
    return (React.createElement(KitConnected
    // createSyncJob={() => createSyncJob({ keys: DEFAULT_SYNC_JOB_KEYS })}
    // isCreatingSyncJob={isCreatingSyncJob}
    // hasSynced={syncStatus.hasSynced}
    // recentSync={syncStatus.recent}
    , null));
};
